<template>
	<div class="d-flex justify-content-between px-2" style="background: rgba(52, 58, 64, 0.5)">
		<span class="text-white p-2">
			<a class="text-white" :href="operatorUrl" target="_blank" rel="noopener noreferrer"
				>&copy;&nbsp;{{ operatorName }}</a
			>
		</span>
		<span class="d-flex flex-wrap justify-content-end text-white p-2">
			<div><a class="text-white" href="/privacy">Datenschutz</a>&nbsp;&#8729;&nbsp;</div>
			<div><a class="text-white" href="/legal">Impressum</a>&nbsp;&#8729;&nbsp;</div>
			<div><a class="text-white text-nowrap" href="/disclosure">Responsible Disclosure</a></div>
		</span>
	</div>
</template>

<script setup lang="ts">
/**
 * The footer of the pages outside the dashboard: the operator and the legal pages. The login
 * layout carries it, and so do public pages of an app that stand on their own, so all of them
 * end the same way.
 */

// Who runs this instance. Set in the admin settings and served through window.config, so a
// customer instance does not credit etherforce next to its own imprint.
const operatorName = globalThis.config?.['app.operator_name'] || 'etherforce GmbH';
const operatorUrl = globalThis.config?.['app.operator_url'] || 'https://www.etherforce.net';
</script>
